import { Component, OnInit } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { ICreateFaxRulePayload } from "src/app/models/fax/create-fax-rule-payload";
import { IFaxFolder } from "src/app/models/fax/fax-folder";
import { IFaxRule } from "src/app/models/fax/fax-rule";
import { FaxService } from "src/app/services/fax.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-filters",
  templateUrl: "./filters.component.html",
  styleUrls: ["./filters.component.scss"],
})
export class FiltersComponent implements OnInit {
  folders: IFaxFolder[] = [];
  selectedFolderName = "";
  isFoldersLoading = true;

  rules: IFaxRule[] = [];
  ruleToEdit: IFaxRule | null = null;
  selectedRule: IFaxRule | null = null;
  isRulesLoading = true;

  private _folderPageNumber = "1";
  private _rulePageNumber = "1";

  private readonly _pageSize = "10";

  constructor(private readonly _faxService: FaxService, private readonly _modalService: ModalService) {}

  createFolder(folderName: string) {
    this._faxService.createFolder({ folderName }).subscribe({
      next: () => this.getFolders(),
    });
  }

  openDeleteFolderModal(folderName: string) {
    this.selectedFolderName = folderName;
    this._modalService.openModal(ModalName.DeleteFaxFolder);
  }

  deleteFolder() {
    const folderName = this.selectedFolderName;

    if (folderName) {
      this._faxService.deleteFolder({ folderName }).subscribe({
        next: () => this.getFolders(),
      });
    }
  }

  openCreateRuleModal() {
    this.ruleToEdit = null;
    this._modalService.openModal(ModalName.CreateFaxRule);
  }

  openEditRuleModal(rule: IFaxRule) {
    this.ruleToEdit = rule;
    this._modalService.openModal(ModalName.CreateFaxRule);
  }

  createRule(payload: ICreateFaxRulePayload) {
    this._faxService.createRule(payload).subscribe({
      next: () => this.getRules(),
    });
  }

  openDeleteRuleModal(rule: IFaxRule) {
    this.selectedRule = rule;
    this._modalService.openModal(ModalName.DeleteFaxRule);
  }

  deleteRule() {
    const rule = this.selectedRule;

    if (rule) {
      this._faxService
        .deleteRule({
          trackingFaxNumber: rule.trackingFaxNumber,
          direction: rule.direction,
          triggerOn: rule.triggerOn,
        })
        .subscribe({
          next: () => this.getRules(),
        });
    }
  }

  ngOnInit() {
    this.getFolders();
    this.getRules();
  }

  private getFolders() {
    return this._faxService
      .getFolders({ pageNumber: this._folderPageNumber, pageSize: this._pageSize })
      .subscribe(folders => {
        this.folders = folders.records;
        this.isFoldersLoading = false;
      });
  }

  private getRules() {
    return this._faxService
      .getRules({ pageNumber: this._rulePageNumber, pageSize: this._pageSize })
      .subscribe(rules => {
        this.rules = rules.records;
        this.isRulesLoading = false;
      });
  }
}
